import { render, staticRenderFns } from "./BloquearTarjeta.vue?vue&type=template&id=393cc6ce&scoped=true"
import script from "./BloquearTarjeta.vue?vue&type=script&lang=js"
export * from "./BloquearTarjeta.vue?vue&type=script&lang=js"
import style0 from "./BloquearTarjeta.vue?vue&type=style&index=0&id=393cc6ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393cc6ce",
  null
  
)

export default component.exports